module.exports = __webpack_public_path__ + "img/C06TechLancerChampion_ua.486be0e9.webp";